// Polish plural: 1 → singular, 2-4 (except 12-14) → few, otherwise → many.
// Example: pluralPL(2, 'liga', 'ligi', 'lig') === 'ligi'
export function pluralPL(count: number, one: string, few: string, many: string): string {
  const abs = Math.abs(count);
  const lastTwo = abs % 100;
  const last = abs % 10;
  if (abs === 1) {
    return one;
  }

  if (last >= 2 && last <= 4 && (lastTwo < 12 || lastTwo > 14)) {
    return few;
  }

  return many;
}
